const PING_STORAGE_PREFIX = 'lastSeenUpdate_';

function isPingSeen(updateKey, serverUpdatedAt) {
    if (!serverUpdatedAt) {
        return true;
    }
    const storageKey = PING_STORAGE_PREFIX + updateKey;
    try {
        const lastSeenTimestamp = localStorage.getItem(storageKey);
        return lastSeenTimestamp && serverUpdatedAt <= lastSeenTimestamp;
    } catch (e) {
        console.error('LocalStorage access error:', e);
        return true;
    }
}

function areAllWindowsPingsSeen(windowElement) {
    const nestedPingButtons = windowElement.querySelectorAll('.ping-button');
    if (nestedPingButtons.length === 0) return true;

    for (const nestedButton of nestedPingButtons) {
        const nestedUpdateKey = nestedButton.dataset.updateKey;
        const nestedServerUpdatedAt = nestedButton.dataset.updatedAt;

        if (!isPingSeen(nestedUpdateKey, nestedServerUpdatedAt)) {
            return false;
        }
    }
    return true;
}

function initializeWindowsPingsSeen(windowElement, id) {
    if (!id) return;
    const nestedPingButtons = windowElement.querySelectorAll('.ping-button');
    if (nestedPingButtons.length === 0) return true;

    for (const nestedButton of nestedPingButtons) {
        nestedButton.dataset.pingParent = id;
    }
}

function showHidePing(pingElement, showPing) {
    if (showPing) {
        pingElement.classList.remove('hidden');
    } else {
        pingElement.classList.add('hidden');
    }
}

export function updatePing(button) {
    if (!button) return;
    const updateKey = button.dataset.updateKey;
    const serverUpdatedAt = button.dataset.updatedAt;
    const pingElement = button.querySelector('.ping');

    if (!updateKey || !pingElement) {
        return;
    }

    const show = !isPingSeen(updateKey, serverUpdatedAt);
    showHidePing(pingElement, show);
}

export function handlePingSeen(button) {
    const updateKey = button.dataset.updateKey;
    const serverUpdatedAt = button.dataset.updatedAt;
    const pingElement = button.querySelector('.ping');
    const windowId = button.dataset.window;
    const windowElement = windowId ? document.getElementById(windowId) : null;

    if (serverUpdatedAt) {
        const storageKey = PING_STORAGE_PREFIX + updateKey;
        try {
            localStorage.setItem(storageKey, serverUpdatedAt);
        } catch (e) {
            console.error('LocalStorage access error:', e);
        }
    }
    if (windowElement) {
        const nestedPingsSeen = areAllWindowsPingsSeen(windowElement);
        showHidePing(pingElement, !nestedPingsSeen);
    } else {
        showHidePing(pingElement, false);
        if (button.dataset.pingParent) {
            const buttonParent = document.getElementById(
                button.dataset.pingParent,
            );
            if (buttonParent) {
                const windowParent = document.getElementById(
                    buttonParent.dataset.window,
                );
                const nestedPingsSeen = areAllWindowsPingsSeen(windowParent);
                const parentPingElement = buttonParent.querySelector('.ping');
                showHidePing(parentPingElement, !nestedPingsSeen);
            }
        }
    }
}

export function initializePings(container) {
    const pingButtons = container.querySelectorAll('.ping-button');
    pingButtons.forEach(async (button) => {
        const updateKey = button.dataset.updateKey;
        const serverUpdatedAt = button.dataset.updatedAt;
        const pingElement = button.querySelector('.ping');
        const windowId = button.dataset.window;
        const windowElement = windowId
            ? document.getElementById(windowId)
            : null;

        if (!updateKey || !pingElement) {
            console.warn(
                'Ping button missing data-update-key or .ping element:',
                button,
            );
            return;
        }

        const pingAlreadySeen = isPingSeen(updateKey, serverUpdatedAt);
        showHidePing(pingElement, !pingAlreadySeen);

        if (windowElement) {
            await new Promise((r) => setTimeout(r, 1000));
            initializeWindowsPingsSeen(windowElement, button.id);
            if (pingAlreadySeen) {
                const nestedPingsSeen = areAllWindowsPingsSeen(windowElement);
                showHidePing(pingElement, !nestedPingsSeen);
            }
        }

        button.addEventListener('click', () => {
            handlePingSeen(button);
        });
    });
}
